export { EventManager as default, preventDefault, stopPropagation, stopEvent } from 'choerodon-ui/dataset';
export { Handler } from 'choerodon-ui/dataset/event-manager';
